import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    // Let browser handle back/forward
    if (navigationType === "POP") return;

    // Let HashScroll handle hash navigation
    if (hash) return;

    // Normal navigation - scroll to top
    window.scrollTo(0, 0);
  }, [pathname, hash, navigationType]);

  return null;
};

export default ScrollToTop;
